import { render, staticRenderFns } from "./AdquisicionCofi.vue?vue&type=template&id=9f34e02a&scoped=true&lang=html&"
import script from "./AdquisicionCofi.vue?vue&type=script&lang=js&"
export * from "./AdquisicionCofi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f34e02a",
  null
  
)

export default component.exports